(function ($) {
    // password reset form
    if ($('.js-reset-password-token').length === 0) {
        return;
    }

    var pwresettoken = window.location.href.substr(window.location.href.indexOf('pwresettoken=') + 13, 32);

    $(() => {
        var theForm = $(".js-reset-password-token");

        theForm.submit(e => {
            e.preventDefault();

            var data = grabFormAsObject(theForm);

            if (validateJsFormRequire(theForm, true)) {
                return false;
            }

            if (pwresettoken) {
                data['pwresettoken'] = pwresettoken;

                apiGetCall('user/pwresettoken', data, (error, result) => {

                    if (error) {
                        $('.js-error-reset-password').text(result.error).removeClass('d-none');
                        window.scrollTo(0, 0);
                        setTimeout(function () {
                            $('.js-error-reset-password').addClass('d-none');
                        }, 3200);
                        return;
                    }

                    if (result.success === true) {
                        theForm.trigger("reset");;
                        $('.js-succes-reset-password').removeClass('d-none');
                        window.scrollTo(0, 0);
                        setTimeout(function () {
                            $('.js-succes-reset-password').addClass('d-none');
                        }, 3200);
                    }

                });
            }
            return false;
        });
    });
})(jQuery);